import { Heading, Text } from '@cleartax/wg-library-typography';
import { forwardRef } from 'react';
import SanitizedHTML from 'react-sanitized-html';
import { usePlanCtx } from '../../../planDetailsContext';
import { SectionConatiner } from '../../ui-blocks/containers';
import { SectionHeading } from '../../ui-blocks/typograpghy';
import { ISection } from '../types';
import styles from './process.module.css';

const HowItsDone: React.FC<ISection> = forwardRef(
  ({ id, name }, ref: React.ForwardedRef<HTMLDivElement>) => {
    const planDetails = usePlanCtx();
    return (
      <div id={id} ref={ref}>
        <SectionConatiner>
          <SectionHeading>{name}</SectionHeading>
          <Text
            type="p"
            className="text-grey-600 pt-6 w-1/2 sm:w-4/5"
            weight="medium"
          >
            {
              'This plan is equipped with end-to-end online fulfillment via our expert. No hassle, 100% Digital.'
            }
          </Text>
          <Heading
            type="h5"
            textSize="xl"
            weight="bold"
            className={`text-brand-1000 pt-6`}
          >
            {`${planDetails.sla} Days Estimate`}
          </Heading>
          <div className="flex pt-5">
            <ul className={styles.process}>
              {planDetails.process.map((service, idx) => {
                return (
                  <li
                    className="text-base text-brand-1000 font-semibold mb-0 pl-12"
                    key={idx}
                  >
                    <SanitizedHTML html={service.richText} />
                  </li>
                );
              })}
            </ul>
          </div>
        </SectionConatiner>
      </div>
    );
  }
);

export { HowItsDone };
